import { Skeleton } from "@/shared/ui";

export default function DetailSkeleton() {
  return (
    <div className="flex justify-start items-start gap-5">
      <div className="flex flex-col flex-1 gap-3">
        <Skeleton className="w-full h-95 radius-3xl" />

        <div className="radius-3xl surface-base-fill px-6 pt-5 pb-5">
          <Skeleton className="w-40 h-5 radius-sm mb-5" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            <Skeleton className="h-20 radius-md" />
            <Skeleton className="h-20 radius-md" />
            <Skeleton className="h-20 radius-md" />
            <Skeleton className="h-20 radius-md" />
          </div>
        </div>

        <div className="radius-3xl surface-base-fill px-6 pt-5 pb-5">
          <Skeleton className="w-48 h-5 radius-sm mb-5" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            <Skeleton className="h-40 radius-md" />
            <Skeleton className="h-40 radius-md" />
            <Skeleton className="h-40 radius-md" />
          </div>
        </div>

        <div className="radius-3xl surface-base-fill px-6 pt-5 pb-5">
          <Skeleton className="w-36 h-5 radius-sm mb-5" />
          <div className="flex flex-col gap-3">
            <Skeleton className="h-10 radius-sm" />
            <Skeleton className="h-10 radius-sm" />
            <Skeleton className="h-10 radius-sm" />
          </div>
        </div>

        <div className="radius-3xl surface-base-fill px-6 pt-5 pb-5">
          <Skeleton className="w-44 h-5 radius-sm mb-5" />
          <Skeleton className="w-full h-48 radius-md" />
        </div>

        <div className="radius-3xl surface-base-fill px-6 pt-5 pb-5">
          <Skeleton className="w-40 h-5 radius-sm mb-5" />
          <div className="grid grid-cols-3 gap-4 mb-6">
            <Skeleton className="h-24 radius-md" />
            <Skeleton className="h-24 radius-md" />
            <Skeleton className="h-24 radius-md" />
          </div>
          <Skeleton className="w-full h-52 radius-lg" />
        </div>
      </div>

      <div className="w-2xs shrink-0 flex flex-col gap-3">
        <div className="radius-3xl surface-base-fill p-5 flex flex-col items-center gap-4">
          <Skeleton className="w-32 h-5 radius-sm" />
          <Skeleton className="w-full h-28 radius-md" />
          <div className="flex flex-col gap-2.5 w-full">
            <Skeleton className="h-5 radius-sm" />
            <Skeleton className="h-5 radius-sm" />
            <Skeleton className="h-5 radius-sm" />
          </div>
          <Skeleton className="w-full h-10 radius-md" />
        </div>

        <div className="radius-3xl surface-base-fill p-5 flex flex-col gap-1">
          <Skeleton className="h-9 radius-md" />
          <Skeleton className="h-9 radius-md" />
          <Skeleton className="h-9 radius-md" />
          <Skeleton className="h-9 radius-md" />
          <Skeleton className="h-9 radius-md" />
        </div>
      </div>
    </div>
  );
}
